module.exports = __webpack_public_path__ + "static/media/twitter-x.9cb7ab6f.svg";